import React from "react";
import { Link } from "react-router-dom";
import { createPageStyles } from "./MarketingPageStyles";

const styles = createPageStyles("light", "dailysign");

type Row = [string, string, string, string];

const tableRows: Row[] = [
  ["로컬 학습 데이터", "학습 진도·스트릭·복습 기록, 즐겨찾기, 앱 설정값", "학습 진행 관리, 진도·통계 표시", "사용자 기기 내 (앱 로컬 저장소)"],
  ["카메라 (따라하기)", "카메라 미리보기 화면 (촬영·저장·전송 없음)", "수어 동작을 거울처럼 비교 연습", "저장하지 않음 (실시간 미리보기 전용)"],
  ["수어 영상 재생", "영상 요청 시 통신 기본 정보 (IP 주소 등)", "국립국어원 한국수어사전 영상 재생", "국립국어원 미디어 서버"],
  ["광고 (Google AdMob)", "광고·기기 식별자, 대략적 위치, 광고·상품 상호작용, 충돌·성능·진단 정보", "무료 구간·보상형 광고 제공 및 성과 분석", "Google 서버 (Google LLC)"],
  ["인앱 구매 (전체 잠금해제)", "상품 ID, 거래 ID·영수증 토큰, 플랫폼, 발생 시각, 오류 코드", "구매 처리 현황 확인 및 복원 지원", "Apple App Store / Google Play 및 Daydream Factory 서버"],
  ["알림", "로컬 알림 설정값, 공지 알림 허용 시 푸시 토큰·기기 식별자·진단 정보", "데일리 학습 및 공지 알림 제공", "사용자 기기 및 Firebase 서버 (Google LLC)"],
];

const copy = {
  crumb: "매일수어 Privacy",
  title: "매일수어,",
  accentTitle: "개인정보 처리방침",
  subtitle:
    "최종 업데이트일: 2026년 10월 13일. 본 정책의 운영 주체는 Daydream Factory입니다. 매일수어는 회원가입 없이 사용할 수 있으며, 학습 기록은 사용자 기기 안에 저장됩니다. 광고·공지 알림·구매 처리 과정에서 아래 정보가 처리될 수 있습니다.",
  tableHead: ["구분", "수집 항목", "사용 목적", "저장 위치"] as Row,
  sections: [
    { title: "1. 수집하는 정보" },
    {
      title: "2. 데이터 사용 목적",
      list: [
        "학습 진도·스트릭·즐겨찾기 관리",
        "따라하기 연습 화면 표시 (카메라 미리보기 전용)",
        "무료 구간 광고 표시 (Google AdMob)",
        "전체 잠금해제 구매 상태 확인 및 복원",
        "데일리 학습 알림과 Firebase Cloud Messaging을 통한 공지 알림",
      ],
    },
    {
      title: "3. 카메라에 관한 안내",
      body:
        "따라하기 기능의 카메라는 실시간 미리보기 전용입니다. 사진·영상을 촬영하거나 저장하지 않으며, 어떤 서버로도 전송하지 않습니다. 카메라 권한을 허용하지 않아도 따라하기 외의 모든 기능을 사용할 수 있습니다.",
    },
    {
      title: "4. 제3자 처리 위탁",
      body: "매일수어는 아래 서비스를 통해 일부 데이터를 처리합니다. 각 서비스의 개인정보 처리방침이 함께 적용됩니다.",
      list: [
        "Google AdMob (Google LLC)",
        "Firebase Cloud Messaging (Google LLC)",
        "Apple App Store / Google Play",
        "국립국어원 한국수어사전 (영상 스트리밍)",
      ],
    },
    {
      title: "5. 광고 식별자",
      body:
        "광고 표시와 성과 측정을 위해 기기의 광고 식별자(IDFA/GAID)와 기기 식별자가 사용될 수 있으며, 기기 식별자는 제3자 광고 목적의 추적에 사용될 수 있습니다. iOS에서는 앱 추적 투명성(ATT) 권한을 요청합니다. 권한을 거부해도 앱의 핵심 기능을 이용할 수 있습니다.",
    },
    {
      title: "6. 데이터 보관 및 삭제",
      list: [
        "학습 기록은 기기에만 저장되며, 앱을 삭제하면 함께 삭제됩니다.",
        "AdMob 및 Firebase 관련 데이터는 Google의 보관 정책에 따릅니다.",
        "구매 이벤트 기록은 구매 처리 확인과 오류 대응에 필요한 기간 동안 보관한 뒤 관계 법령과 내부 정책에 따라 삭제합니다.",
      ],
    },
    {
      title: "7. 이용자 권리 및 문의",
      body:
        "이용자는 앱 삭제로 기기 내 학습 데이터를 삭제할 수 있으며, 서버에 저장된 구매 이벤트 기록의 열람·삭제는 문의할 수 있습니다. 개인정보 관련 문의: support@daydreamfactory.net",
    },
  ],
  websiteStats: {
    title: "8. 웹사이트 정보",
    body: "본 페이지(daydreamfactory.net)는 방문 통계 측정을 위해 익명화된 분석 도구를 사용할 수 있습니다.",
    list: ["수집 항목: 페이지 조회, 익명 기기/브라우저 정보", "목적: 사이트 개선"],
  },
};

const DailySignPrivacyPolicy: React.FC = () => {
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      document.documentElement.lang = "ko";
    }
  }, []);

  return (
    <main style={styles.page}>
      <div style={styles.shell}>
        <div style={styles.topRow}>
          <Link to="/" style={styles.homeLink}>
            ← Daydream Factory
          </Link>
          <span style={styles.crumb}>{copy.crumb}</span>
        </div>

        <section style={styles.hero}>
          <h1 style={styles.title}>
            {copy.title}
            <br />
            <span style={styles.accentTitle}>{copy.accentTitle}</span>
          </h1>
          <p style={styles.subtitle}>{copy.subtitle}</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>{copy.sections[0].title}</h2>
          <div style={styles.sectionCard}>
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    {copy.tableHead.map((item) => (
                      <th key={item} style={styles.thtd}>
                        {item}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableRows.map((row) => (
                    <tr key={row[0]}>
                      {row.map((cell) => (
                        <td key={cell} style={styles.thtd}>
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {copy.sections.slice(1).map((section) => (
          <section key={section.title} style={styles.section}>
            <h2 style={styles.h2}>{section.title}</h2>
            <div style={styles.sectionCard}>
              {section.body ? (
                <p style={styles.body}>
                  {section.body.includes("support@daydreamfactory.net") ? (
                    <>
                      {section.body.replace("support@daydreamfactory.net", "")}
                      <a href="mailto:support@daydreamfactory.net" style={styles.link}>
                        support@daydreamfactory.net
                      </a>
                    </>
                  ) : (
                    section.body
                  )}
                </p>
              ) : null}
              {section.list ? (
                <ul style={styles.list}>
                  {section.list.map((item) => (
                    <li key={item}>
                      {item === "Google AdMob (Google LLC)" ? (
                        <>
                          Google AdMob (Google LLC) -{" "}
                          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={styles.link}>
                            Google Privacy Policy
                          </a>
                        </>
                      ) : item === "Firebase Cloud Messaging (Google LLC)" ? (
                        <>
                          Firebase Cloud Messaging (Google LLC) -{" "}
                          <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer" style={styles.link}>
                            Firebase Privacy &amp; Security
                          </a>
                        </>
                      ) : item === "Apple App Store / Google Play" ? (
                        <>
                          Apple App Store / Google Play -{" "}
                          <a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noreferrer" style={styles.link}>
                            Apple Privacy Policy
                          </a>
                        </>
                      ) : (
                        item
                      )}
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
        ))}

        <section style={styles.section}>
          <h2 style={styles.h2}>{copy.websiteStats.title}</h2>
          <div style={styles.sectionCard}>
            <p style={styles.body}>{copy.websiteStats.body}</p>
            <ul style={styles.list}>
              {copy.websiteStats.list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </main>
  );
};

export default DailySignPrivacyPolicy;
